import { FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import Banking from 'components/ui/GeneralInformation/Banking';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import { DS_TOKENS } from 'constants/styled.contants';
import { textConstants } from 'constants/texts';
import React, { FC } from 'react';
import { abreviatedMonthToNumber } from 'utils';
import CurrentCapacity from './CurrentCapacity';
import DownloadVerifiedProfile from './DownloadVerifiedProfile';
import LastLocation from './LastLocation';
import TimeSinceCreated from './TimeSinceCreated';
import TruckerAvailability from './TruckerAvailability';
import UsuallyLoads from './UsuallyLoads';
import { GeneralInformationProps } from './types';

const GeneralInformation: FC<GeneralInformationProps> = ({ data, isOpenSearch }) => {
  const { noInfoText } = textConstants;

  return (
    <FuelFlex
      defaultProps={{ flexDirection: 'column', customPadding: `${DS_TOKENS.spacing.km4} ${DS_TOKENS.spacing.km6}` }}
    >
      <FuelFlex
        defaultProps={{
          alignContent: 'center',
          justifyContent: 'space-between',
          customMargin: `0 0 ${DS_TOKENS.spacing.km2}`,
          flexWrap: 'wrap',
        }}
        smProps={{
          alignContent: 'flex-start ',
          gap: 'km4',
        }}
      >
        <FuelTypography size="heading-sm" weight="bold">
          Informações gerais
        </FuelTypography>
        {data?.trucker?.availability?.isAvailable && isOpenSearch && (
          <FuelTag
            label="disponível"
            highlight
            uppercase
            color="blue"
            shape="rectangle"
            data-testid="test-tag-available"
          />
        )}
      </FuelFlex>

      <GenericInfoItem title="Mora em">
        <FuelTypography weight="medium">
          {data?.trucker?.address?.city && data?.trucker?.address?.state
            ? `${data?.trucker?.address?.city}, ${data?.trucker?.address?.state}`
            : noInfoText}
        </FuelTypography>
      </GenericInfoItem>

      <LastLocation trucker={data?.trucker} />

      <TruckerAvailability {...data?.trucker?.availability} />
      <CurrentCapacity {...data?.trucker?.availability} />

      <UsuallyLoads mainProducts={data?.trucker?.mainProducts} />

      <GenericInfoItem title="CNH">
        <FuelTypography weight="medium">
          {data?.trucker?.cnh?.category && data?.trucker?.cnh?.expirationDate
            ? `Categoria ${data?.trucker?.cnh?.category} • Válida até ${abreviatedMonthToNumber(
                data?.trucker?.cnh?.expirationDate
              )}`
            : noInfoText}
        </FuelTypography>
      </GenericInfoItem>
      <GenericInfoItem title="Tempo de habilitação">
        <FuelTypography weight="medium">
          {data?.trucker?.cnh?.timeSinceFirstLicense ? data?.trucker?.cnh?.timeSinceFirstLicense : noInfoText}
        </FuelTypography>
      </GenericInfoItem>
      <TimeSinceCreated
        registrationDate={data?.trucker?.registrationDate}
        timeSinceCreated={data?.trucker?.timeSinceCreated}
      />
      <DownloadVerifiedProfile data={data} />
      <Banking data={data} />
    </FuelFlex>
  );
};

export default GeneralInformation;
